import { NotificationService } from 'src/app/core/services/notification.service';

export function handleDeviceAssignmentError(
  err: any,
  notificationService: NotificationService,
): boolean {
  const msg = err?.error?.message;

  if (msg === 'DEVICE.ERRORS.OCCUPIED') {
    notificationService.error(
      'Device is already occupied, please choose some other device',
    );
    return true;
  }

  if (msg === 'DEVICE.ERRORS.ASSIGNED_TO_PATIENT') {
    const info = err?.error?.errors?.[0];
    const serial = info?.deviceSerial ?? 'Unknown';
    const name = info?.patientName ?? `Patient #${info?.patientDbId ?? '?'}`;
    const pid = info?.patientId ?? info?.patientDbId ?? '—';
    notificationService.openDialog({
      title: 'Device already assigned',
      message: `Device ${serial} is currently assigned to patient ${name} (ID: ${pid}). To assign a different device, unassign device ${serial}.`,
      cancelButtonHide: true,
      confirmButtonText: 'OK',
      onConfirm: () => {},
      onCancel: () => {},
    });
    return true;
  }

  return false;
}
